import { supertypeClass, property } from '@haventech/amorphic';
import { Everything } from '@hit/amorphic-types';
import { Assumptions } from '../static/Assumptions';
import { Customer } from './Customer';
import { DiagnosisShort as GQLDiagnosisShort } from '@hit/hit-api-client';

@supertypeClass({ toClient: true, toServer: true })
export class DiagnosisShort extends Everything implements GQLDiagnosisShort {
  @property({ rule: ['required', 'text'], validate: 'isNotEmptyAndMinLength(2)' })
  physician: string = '';

  @property({ rule: ['telephone'] })
  physicianPhone: string = '';

  @property({ rule: ['required', 'shortdate', 'pastDate'] })
  date: Date = null;

  @property({ rule: ['required', 'geoName'], validate: 'isNotEmptyAndMinLength(2); isMaxLength(86)' })
  city: string = '';

  @property({ rule: ['required'], values: Assumptions.stateValues })
  state: string = '';

  @property({ rule: ['required', 'text'], validate: 'isNotEmptyAndMinLength(2)' })
  diagnosis: string = '';

  @property({ rule: ['numericPositive'], comment: 'Duration of treatment in terms of number of days' })
  duration: number;

  @property({ rule: ['required', 'text'], validate: 'isNotEmptyAndMinLength(2)' })
  diagnosisDetails: string = '';

  @property({ getType: () => Customer })
  customer: Customer;

  constructor() {
    super();
  }

  static new(customer: Customer): DiagnosisShort {
    return new DiagnosisShort().init(customer);
  }

  init(customer: Customer): this {
    this.customer = customer;
    return this;
  }
}
